import styled from "@emotion/styled";
import { respond } from "../../styles/responsive";
import TickSvg from "../../images/tick.svg";
import { Field } from "formik";
export const SINGLE_COLUMN = "768px";
export const Wrapper = styled.div`
    width: 100%;
    max-width: 1800px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    ${respond(37, 40, "px", "paddingBottom")};

    @media screen and (min-width: 1080px) {
        align-items: flex-start;
        flex-direction: row;
    }
`;
export const Input = styled(Field)`
    ${respond(16, 20)};
    font-family: FoundryGridnik, sans-serif;
    font-weight: 500;
    appearance: none;
    background: white;
    border: 0;
    padding: 15px 30px;
    width: 100%;
    box-sizing: border-box;
    @media screen and (min-width: 1400px) {
        padding: 15px 30px 15px;
    }

    &::placeholder {
        text-transform: uppercase;
        color: #b3b3b3;
    }
`;
export const Submit = styled.button`
    color: white;
    border: 1px solid white;
    padding: 0;

    text-transform: uppercase;
    font-family: FoundryGridnik, sans-serif;
    font-weight: 500;
    letter-spacing: 0.065em;
    background: black;
    ${respond(56, 62, "px", "height")};
    ${respond(16, 18)};
    cursor: pointer;
    grid-area: submit;
    position: relative;
    width: 100%;
    @media screen and (min-width: ${SINGLE_COLUMN}) {
        width: 263px;
        margin-top: 5px;
    }
    @media screen and (min-width: 1400px) {
        justify-self: flex-end;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;
export const Label = styled.label`
    font-size: 14px;
    color: white;
    text-transform: uppercase;
    margin-bottom: 10px;
    font-family: "IBM Plex Sans", sans-serif;
    position: relative;
`;

export const RadioGroupLabel = styled.div`
    font-size: 14px;
    color: white;
    text-transform: uppercase;
    margin-bottom: 17px;
    font-family: "IBM Plex Sans", sans-serif;
    @media screen and (min-width: ${SINGLE_COLUMN}) {
        margin-bottom: 8px;
    }
`;
export const InputContainer = styled.div`
    opacity: ${props => (props.faded ? 0.5 : 1)};
    pointer-events: ${props => (props.faded ? "none" : "all")};
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 24px;
`;
export const FieldContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: stretch;

    &.hidden {
        display: none;
    }
`;
export const OptionsContainer = styled.label`
    cursor: pointer;
    display: block;
    margin-bottom: 15px;
    &:last-of-type {
        margin-bottom: 0;
    }
`;
export const CheckboxLabel = styled.div`
    color: white;
    font-size: 18px;
    font-family: FoundryGridnik, sans-serif;
    font-weight: 500;
    letter-spacing: 0.065em;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-right: 35px;

    &::before {
        content: "";
        background: none;
        border: 1px solid white;
        padding: 14px;
        display: inline-block;
        transition: background-color 0.2s ease;
    }

    &::after {
        content: "";
        display: inline-block;
        position: absolute;
        width: 28px;
        height: 28px;
        top: 1px;
        left: 1px;
        opacity: 0;
        transition: opacity 0.2s ease;
        background-image: url(${TickSvg});
        background-position: center center;
        background-repeat: no-repeat;
    }

    span,
    p {
        display: inline-block;
        margin-left: 16px;
    }
`;
export const CheckboxInput = styled(Field)`
    opacity: 0;
    position: absolute;
    &:checked + ${CheckboxLabel} {
        &::before {
            background: white;
        }
        &::after {
            opacity: 1;
        }
    }
`;

export const ErrorText = styled.div`
    text-align: left;
    ${respond(16, 20)};
`;
